import React, { useMemo, useCallback, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import { useScroll } from '../hooks/useScroll';
import { useMobileMenu } from '../hooks/useMobileMenu';
import { NAV_ITEMS, SCROLL_THRESHOLD } from '../utils/constants';
import './Header.css';

const Header = React.memo(() => {
  const location = useLocation();
  const isScrolled = useScroll(SCROLL_THRESHOLD);
  const { isOpen: isMobileMenuOpen, toggle: toggleMobileMenu, close: closeMobileMenu } = useMobileMenu();

  // Close mobile menu on route change
  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname, closeMobileMenu]);

  const isActive = useCallback((path) => {
    return location.pathname === path;
  }, [location.pathname]);

  const navItems = useMemo(() => NAV_ITEMS, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo-link">
          <Logo size="medium" showText={false} />
        </Link>
        
        <nav className={`nav ${isMobileMenuOpen ? 'mobile-open' : ''}`} aria-label="Main navigation">
          {navItems.map((item) => (
            <Link 
              key={item.path}
              to={item.path} 
              className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
});

Header.displayName = 'Header';

export default Header;

